











import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { BankAccount, MangoPayMandate } from '@/store/mangoPay/types';
import { MangoPayUser, User } from '@/store/profile/types';
import BankAccountList from '@/components/bankAccount/BankAccountList.vue';
import BankAccountDetails from '@/components/bankAccount/BankAccountDetails.vue';

@Component({
  name: 'bank-account-details',
  components: {
    BankAccountList,
    BankAccountDetails,
  },
})
export default class BankAccountWrapper extends Vue {
  @Getter('mangoPay/bankAccounts') bankAccounts?: Array<BankAccount>;
  @Getter('mangoPay/loadingBankAccounts') loadingBankAccounts?: Boolean;
  @Getter('mangoPay/getBankAccountById') getBankAccountById?: Function;
  @Getter('mangoPay/bankAccountMandate') bankAccountMandate?: Function;

  @Action('mangoPay/fetchUserBankAccounts') fetchUserBankAccounts: Function;

  accountId: string | null = null;
  bankAccount: BankAccount = null;
  mandate: MangoPayMandate = null;

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    this.accountId = this.$route.params.accountId
      ? this.$route.params.accountId
      : null;

    this.getBankAccount();
  }

  created() {
    this.getBankAccount();
  }

  get hasBankAccounts() {
    return this.bankAccounts && this.bankAccounts.length > 0;
  }

  private async getBankAccount() {
    const isCreatingAccount = this.$route.path.includes('create');

    if (this.hasBankAccounts && this.accountId) {
      this.bankAccount = this.getBankAccountById(this.accountId);
      this.mandate = this.bankAccountMandate(this.accountId);
    }
  }
}
